var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 42,
    height: 39,
    rx: 3.5,
    stroke: "#0000A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4985 15.9981C24.4714 14.971 23.0619 14.3335 21.4964 14.3335C18.3656 14.3335 15.8369 16.8693 15.8369 20.0002C15.8369 23.131 18.3656 25.6668 21.4964 25.6668C24.1385 25.6668 26.3414 23.8606 26.9719 21.4168H25.4985C24.9177 23.0672 23.3452 24.2502 21.4964 24.2502C19.1519 24.2502 17.2464 22.3447 17.2464 20.0002C17.2464 17.6556 19.1519 15.7502 21.4964 15.7502C22.6723 15.7502 23.7206 16.2389 24.4856 17.011L22.2048 19.2918H27.1631V14.3335L25.4985 15.9981Z",
    fill: "#0000A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetImage);
export default __webpack_public_path__ + "static/media/resetImage.0f8b7951b8ad3a4a078dac1386ea4f2c.svg";
export { ForwardRef as ReactComponent };